import { Box, Skeleton } from '@mui/material';
import { SkeletonList } from '../../../../components/skeleton-list/SkeletonList';
import { ProfilePageHeaderSkeleton } from '../../shared/ProfilePageHeaderSkeleton';

export const ResetPasswordPageSkeleton = () => {
  return (
    <Box>
      <ProfilePageHeaderSkeleton />
      <SkeletonList itemsCount={3} variant="rectangular" sx={{ mb: 2.5 }} height="3rem" width="min(100%, 25rem)" />
      <Skeleton variant="rectangular" height="2.5rem" width="7.5rem" />
    </Box>
  );
};
